import React, { useState, useContext, useEffect } from "react";
import "./style/Nav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Badge from "@material-ui/core/Badge";
import { Context, BasketContext } from "./context/Context";
import { Link, useHistory } from "react-router-dom";

function Nav() {
  const [text, setText] = useState("");
  const [term, setTerm] = useContext(Context);

  const [basket, setBasket] = useContext(BasketContext);

  const history = useHistory();

  const HandleChange = (e) => {
    setText(e.target.value);
  };

  const HandleSubmit = (e) => {
    e.preventDefault();
    setTerm(text);
    history.push("/Browse");
  };

  return (
    <div className="nav">
      <div className="nav__search">
        <form onSubmit={HandleSubmit}>
          <FontAwesomeIcon icon={faSearch} onClick={HandleSubmit} />
          <input
            type="text"
            value={text}
            placeholder="Search for books.."
            onChange={HandleChange}
          />
        </form>
      </div>
      <div className="nav__icon">
        <Link to="/Basket">
          <Badge badgeContent={basket.length} color="error">
            <FontAwesomeIcon icon={faShoppingCart} />
          </Badge>
        </Link>
        <Badge variant="dot" color="error">
          <FontAwesomeIcon icon={faBell} />
        </Badge>
      </div>
    </div>
  );
}

export default Nav;
